import { useEffect, useRef } from 'react'
import IconUploadSvg from '../../assets/images/icon-upload.svg'
import './styles.scss'
import { useDragging } from '../../hooks/uploadFile/useDragging'
import { useUploadFile } from '../../hooks/uploadFile'
import { IUploadFileProps } from './types'
import Lottie from 'react-lottie'
import successAnimation from '../../assets/animations/success-animation.json'
import { CircleX, Hand } from 'lucide-react'
import { Loader } from '../loader'

export const UploadFile = (props: IUploadFileProps) => {
  const { handlerChangeFile, error, cleanError, file, status } = useUploadFile()
  const uploadRef = useRef<HTMLInputElement>(null)
  const uploaderRef = useRef<HTMLDivElement>(null)

  const onDrop = (event: DragEvent) => {
    const draggedFiles = event.dataTransfer?.files

    if (!draggedFiles || !draggedFiles.length) return

    handlerChangeFile(draggedFiles[0])
  }

  const { isDragging } = useDragging({
    containerRef: uploaderRef,
    onDrop,
  })

  useEffect(() => {
    if (!isDragging || !error) return

    cleanError()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDragging, error])

  const handleChange = () => {
    const files = uploadRef.current?.files

    if (!files?.length) return

    handlerChangeFile(files[0])
  }

  const defaultOptions = (animationData: object) => ({
    loop: false,
    autoplay: true,
    animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  })

  const renderContentUpload = () => {
    if (status === 'progress') {
      return (
        <div className="content-load">
          <Loader />
        </div>
      )
    }

    if (isDragging) {
      return (
        <div className="content-dragging">
          <Hand size={35} className="icon-dragging" />
          <span>Solte para fazer o upload</span>
        </div>
      )
    }

    if (error) {
      return (
        <div className="upload-error">
          <CircleX size={50} className="content-info-erro" />
          <span className="content-info-erro">{error}</span>
        </div>
      )
    }

    if (status === 'success') {
      return (
        <div className="upload-success">
          <Lottie
            options={defaultOptions(successAnimation)}
            height={100}
            width={150}
          />
          <span className="file-name">{file?.name}</span>
        </div>
      )
    }

    return (
      <>
        <img src={IconUploadSvg} className="icon-upload" alt="upload icon" />

        <div className="container-info-upload">
          <span className="container-info-upload-title">
            Arraste ou faça Upload do Arquivo
          </span>

          <p className="container-info-upload-description">
            O arquivo deve ter no máximo 2 MB e dimensões de 1080 x 920 px.
          </p>
        </div>
      </>
    )
  }

  return (
    <div className="container-root-upload">
      {status === 'progress' && (
        <svg className="container-svg-progress" height="100%" width="100%">
          <rect
            rx="8"
            ry="8"
            className="line"
            height="100%"
            width="100%"
            stroke-linejoin="round"
          />
        </svg>
      )}

      <div
        ref={uploaderRef}
        onClick={() => {
          cleanError()
          uploadRef.current?.click()
        }}
        className={`container-main-upload ${error && 'error'} ${status}`}
        style={{
          height: props.height ?? 244,
          pointerEvents: status === 'progress' ? 'none' : 'auto',
        }}
        {...props}
      >
        <input
          ref={uploadRef}
          onChange={handleChange}
          disabled={status === 'progress'}
          type="file"
          name="upload"
          accept="image/png, image/jpeg, image/jpg"
          id="upload"
          hidden
        />

        {renderContentUpload()}
      </div>
    </div>
  )
}
